import { queryOptions } from '@tanstack/react-query';
import { fetchNotifications, fetchUnreadCount } from './api';
import type { FetchNotificationDto } from '@repo/api';

export const notificationQueryKeys = {
  all: (tenantId?: string) => ['notification', tenantId] as const,
  lists: (tenantId?: string) =>
    [...notificationQueryKeys.all(tenantId), 'list'] as const,
  list: (tenantId: string, params?: FetchNotificationDto) =>
    queryOptions({
      queryKey: [...notificationQueryKeys.lists(tenantId), params],
      queryFn: () => fetchNotifications(tenantId, params),
    }),
  unreadCounts: (tenantId?: string) =>
    [...notificationQueryKeys.all(tenantId), 'unread-count'] as const,
  unreadCount: (tenantId: string) =>
    queryOptions({
      queryKey: notificationQueryKeys.unreadCounts(tenantId),
      queryFn: () => fetchUnreadCount(tenantId),
    }),
};
